export const FULLSCREEN_LOADING_START = 'loadSpinner/LOADING_START'
export const FULLSCREEN_LOADING_END = 'loadSpinner/LOADING_END'

export function startFullScreenLoading() {
  return {
    type: FULLSCREEN_LOADING_START,
  }
}

export function endFullScreenLoading() {
  return {
    type: FULLSCREEN_LOADING_END,
  }
}
